var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.974609 1.6C0.974609 0.716345 1.69095 0 2.57461 0H8.97461C9.18678 0 9.39027 0.0842855 9.54029 0.234315L13.5403 4.23431C13.6903 4.38434 13.7746 4.58783 13.7746 4.8V14.4C13.7746 15.2837 13.0583 16 12.1746 16H2.57461C1.69095 16 0.974609 15.2837 0.974609 14.4V1.6ZM8.64324 1.6L2.57461 1.6V14.4H12.1746V5.13137L8.64324 1.6Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17461 0C8.61644 0 8.97461 0.358172 8.97461 0.8V4.8H12.9746C13.4164 4.8 13.7746 5.15817 13.7746 5.6C13.7746 6.04183 13.4164 6.4 12.9746 6.4H8.17461C7.73278 6.4 7.37461 6.04183 7.37461 5.6V0.8C7.37461 0.358172 7.73278 0 8.17461 0Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17461 8.8C4.17461 8.35817 4.53278 8 4.97461 8H9.77461C10.2164 8 10.5746 8.35817 10.5746 8.8C10.5746 9.24183 10.2164 9.6 9.77461 9.6H4.97461C4.53278 9.6 4.17461 9.24183 4.17461 8.8Z",
    fill: "#21272F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17461 12C4.17461 11.5582 4.53278 11.2 4.97461 11.2H9.77461C10.2164 11.2 10.5746 11.5582 10.5746 12C10.5746 12.4418 10.2164 12.8 9.77461 12.8H4.97461C4.53278 12.8 4.17461 12.4418 4.17461 12Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.ccfdfbdb02df0be78c136dd11a7efb3f.svg";
export { ForwardRef as ReactComponent };